import {IReduxState} from 'app/types/state';

export const getIsFetching = (state: IReduxState) => state.newsReducer.isFetching;
export const getNewsSelector = (state: IReduxState) => state.newsReducer.news;
export const getNewsItemSelector = (state: IReduxState) => state.newsReducer.newsItem;
export const getTotalCount = (state: IReduxState) => state.newsReducer.totalCount;
export const getOffset = (state: IReduxState) => state.newsReducer.offset;
